import { EventEmitter } from '@angular/core'
import { Injectable } from '@angular/core'
import { Snackbar } from '../models/Snackbar'

@Injectable()
export class NotificationService {
	public notifier = new EventEmitter<object>()
	public starterLoading = new EventEmitter<void>()
	public stopperLoading = new EventEmitter<void>()
	public loggedTownHall = new EventEmitter<boolean>()
	public isLoading: boolean = false

	public notify(message: string, code: number): void {
		const objectSnack: Snackbar = new Snackbar()
		objectSnack.code = code
		objectSnack.message = message
		this.notifier.emit(objectSnack)
	}

	public initLoading(): void {
		this.isLoading = true
		this.starterLoading.emit()
	}

	public stopLoading(): void {
		this.isLoading = false
		this.stopperLoading.emit()
	}
}
